import { colors } from '@/utils';

export type TemplateIconPalette = {
  fill: string;
  fillOpacity: number;
  stroke: string;
  /** Outline of the extent (the screen), drawn over the cells. */
  frame?: string;
  /** Outline used instead of `frame` when widgets reach past the extent. */
  overflowFrame?: string;
};

/**
 * `default` tints from `currentColor`, which reads well on modal and menu backgrounds.
 * `onSurface` is for small icons on the near-black card surface: an opaque soft fill with a solid
 * stroke, using the same info family as the feed silo labels, plus a neutral screen outline that
 * turns dim red when the layout does not fit on the screen.
 */
export const TEMPLATE_ICON_APPEARANCES = {
  default: {
    fill: 'currentColor',
    fillOpacity: 0.2,
    stroke: 'currentColor',
  },
  onSurface: {
    fill: colors.background.info.soft[200],
    fillOpacity: 1,
    stroke: colors.background.info.solid[100],
    frame: colors.stroke.neutral.solid[100],
    overflowFrame: colors.stroke.alarm.soft[50],
  },
} satisfies Record<string, TemplateIconPalette>;

export type TemplateIconAppearance = keyof typeof TEMPLATE_ICON_APPEARANCES;
